import { Twitch, Youtube, Twitter, Instagram, MessageSquare } from "lucide-react";

const ITEMS = [
  { key: "social_twitch_url",    label: "Twitch",    Icon: Twitch },
  { key: "social_discord_url",   label: "Discord",   Icon: MessageSquare },
  { key: "social_youtube_url",   label: "YouTube",   Icon: Youtube },
  { key: "social_twitter_url",   label: "X",         Icon: Twitter },
  { key: "social_instagram_url", label: "Instagram", Icon: Instagram },
];

export default function SocialStrip({ settings, themeColor = "#00E5FF" }) {
  const visible = ITEMS.filter(i => (settings?.[i.key] || "").trim());
  if (visible.length === 0) return null;
  return (
    <div className="flex items-center gap-3" data-testid="social-strip">
      {visible.map(({ key, label, Icon }) => (
        <a
          key={key}
          href={settings[key]}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
          title={label}
          className="text-neutral-400 hover:text-current transition-colors"
          style={{ "--hc": themeColor }}
          onMouseEnter={(e) => { e.currentTarget.style.color = themeColor; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = ""; }}
          data-testid={`social-${label.toLowerCase()}`}
        >
          <Icon className="w-4 h-4" />
        </a>
      ))}
    </div>
  );
}
